import { mergeStyles, TextField } from '@fluentui/react';
import * as React from 'react';
import { AddNoteConfig } from '../../../../models/reduxState';
import { Note } from '../../models/requestModels';
import { getCommonClassNames, getCommonStyles } from '../../styles/commonStyles';
import { IRequestDetailsStyles, getFieldClassNames, getFieldStyles, getRequestDetailsClassNames } from '../../styles/requestDetailsStyles';
import { IStyledComponent } from '../../styles/themesUI';
import { getString } from '../../../../../web/utils/stringLoader';

interface INotesFieldComponentProps {
  addNoteConfig: AddNoteConfig;
  market: string;
  // dispatchers
  updateNote: (note: string) => void;
}

interface IRequestDetailsNotesProps {
  notes: Note[];
  isRequestDetailsEditMode: boolean;
}

type INotesFieldProps = INotesFieldComponentProps & IRequestDetailsNotesProps & IStyledComponent<IRequestDetailsStyles>;

export class NotesField extends React.PureComponent<INotesFieldProps> {
  public render(): React.ReactNode {
    if (!this.props.notes) {
      return null;
    }

    const requestDetailsClassNames = getRequestDetailsClassNames(
      this.props.styles,
      { theme: this.props.theme }
    );
    const commonClassNames = getCommonClassNames(getCommonStyles);
    const maxAllowedNotesCount = this.props.addNoteConfig ? this.props.addNoteConfig.MaxAllowedNotesCount : 6;
    const notesList = this.props.notes;
    return !!notesList && notesList.length >= 2 ? (
      <div className={requestDetailsClassNames.sectionContainer}>
        <div
          className={mergeStyles(
            commonClassNames.fontWeightBold,
            requestDetailsClassNames.contentContainer
          )}
        >
          <span>{getString('notesField_notesLabel')}</span>
        </div>
        {this.getNoteDisplayComponents(notesList)}
        {notesList.length <= maxAllowedNotesCount &&
          this.props.isRequestDetailsEditMode && (
            this.getEditModeComponents()
          )}
      </div>
    ) : null;
  }

  private getNoteDisplayComponents = (
    notesList: Note[]
  ) => {
    const fieldClassNames = getFieldClassNames(getFieldStyles, {
      theme: this.props.theme,
    });
    const commonClassNames = getCommonClassNames(getCommonStyles!, {});
    // Splice the notes list here since the first note is user description added by Rave.
    notesList.splice(0, 1);
    const globalMarket = !!this.props.market ? this.props.market : 'en-US';
    const hasNote = !!notesList && notesList.length >= 1;
    return !!hasNote && (
      <div className={fieldClassNames.notesDisplayContainer}>
        {notesList.map((note: Note, index: number) => {
          let date = '';
          let time = '';
          if (!!note.Time) {
            date = new Date(note.Time).toLocaleDateString();
            time = new Date(note.Time).toLocaleTimeString(globalMarket);
          }
          return (
            date &&
            time && (
              <div className={fieldClassNames.noteContainer} key={`Note_${index}`}>
                <div className={mergeStyles(commonClassNames.ellipsisText, fieldClassNames.noteTime)}>{date}&nbsp;&nbsp;{time}</div>
                <div className={mergeStyles(commonClassNames.ellipsisText, fieldClassNames.noteName)}>{note.Text}</div>
              </div>
            )
          );
        })
        }
      </div>
    );
  };

  private getEditModeComponents = () => {
    const fieldClassNames = getFieldClassNames(getFieldStyles, {
      theme: this.props.theme,
    });
    return (
      <div className={fieldClassNames.fieldInputGroup}>
        <TextField
          id='userNotesInput'
          className={fieldClassNames.fieldInput}
          type='text'
          maxLength={this.props.addNoteConfig.AddNoteTextFieldCharLimit}
          placeholder={getString('notesField_notesPlaceHolder')}
          onChange={this.onUserNotesInputChange}
        />
      </div>
    );
  };

  private onUserNotesInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!!event && !!event.target) {
      event.stopPropagation();
      this.props.updateNote(event.target.value);
    }
  };
}
